export enum AppLanguage {
  English = 'en',
  Slovenian = 'sl',
}
